import React, { FC, useCallback } from 'react'
import { Layout } from 'components/Layout'
import { CompleteTemplate } from 'components/Templates'
import { useDispatch } from 'react-redux'
import { push } from 'connected-react-router'

const InformationComplete: FC = () => {
  const dispatch = useDispatch()
  const backToTopPage = useCallback(() => {
    dispatch(push('/account'))
  }, [])

  return (
    <Layout title={'完了 | 店舗基本情報を編集'}>
      <CompleteTemplate
        description={'sacriのアプリからご確認ください'}
        iconPath={'/icon/done/shop.svg'}
        label={'お店の基本情報の編集が\n登録されました！'}
        backToTop={backToTopPage}
      />
    </Layout>
  )
}

export default InformationComplete
